var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45741 3.17647L6.86016 3.47276C6.95017 3.3504 6.97968 3.19377 6.94037 3.04706C6.90106 2.90034 6.79719 2.77945 6.65806 2.71849L6.45741 3.17647ZM9.5 7.49999C9.5 9.43299 7.933 11 6 11V12C8.48528 12 10.5 9.98527 10.5 7.49999H9.5ZM6 11C4.067 11 2.5 9.43299 2.5 7.49999H1.5C1.5 9.98527 3.51472 12 6 12V11ZM2.5 7.49999C2.5 5.56699 4.067 3.99999 6 3.99999V2.99999C3.51472 2.99999 1.5 5.01471 1.5 7.49999H2.5ZM8.18726 4.76743C8.98844 5.40967 9.5 6.39492 9.5 7.49999H10.5C10.5 6.07867 9.84049 4.81106 8.81274 3.98718L8.18726 4.76743ZM3.3243 2.34963L6.25676 3.63444L6.65806 2.71849L3.72561 1.43369L3.3243 2.34963ZM6.05465 2.88018L4.15747 5.45908L4.96299 6.05166L6.86016 3.47276L6.05465 2.88018Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9eed123b58625ac026ed13609127face.svg";
export { ForwardRef as ReactComponent };